import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePCountry, PCountry } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<PCountry>
      useData={usePCountry}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
